import React from 'react';
import '../App.css'
import { Link } from 'react-router-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
import { Combobox } from '@headlessui/react'
import { userService } from '../services/UserService';
import { deleteLocalStorage, authHeader, gettokens, getDidTokens } from "../helpers/auth-header";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import Axios from "axios";
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Fragment, useState } from 'react'
import { Dialog, Menu, Transition } from '@headlessui/react'
import {
	Bars3Icon,
	BellIcon,
	GlobeEuropeAfricaIcon,
	ChartPieIcon,
	Cog6ToothIcon,
	DocumentDuplicateIcon,
	ChatBubbleBottomCenterIcon,
	PlusCircleIcon,
	UsersIcon,
	XMarkIcon,
	UserCircleIcon,
	CalendarIcon,
	FolderIcon,
	HomeIcon,
	VideoCameraIcon,
	CreditCardIcon,
	BookOpenIcon,
	EllipsisVerticalIcon,
	CircleStackIcon
} from '@heroicons/react/24/outline'
import { ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'




var url = process.env.REACT_APP_URL || "http://localhost:8080/";
function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}
const navigation = [
	{ name: 'New experience', href: '/#/storycreation', icon: PlusCircleIcon, current: false },
	{ name: 'New video', href: '/#/', icon: PlusCircleIcon, current: true },
	{ name: 'Experience library', href: '/#/tourlibrary', icon: BookOpenIcon, current: false },
	{ name: 'Video library', href: '/#/library', icon: VideoCameraIcon, current: false },

]

const userNavigation = [
	{ name: 'Your profile', href: '#' },
	{ name: 'Sign out', href: '#' },
]


function SideMenu({ sidebarOpen, setSidebarOpen, admin, setUpdateapi, handleLogout, handleCountTokens, library, storycreation, tourlibrary }) {
	const librarySelected = library;
	const storyCreationSelected = storycreation;
	for (let item of navigation) {
		if (item.name === 'Video library' && library) {
			item.current = true;
		} else if (item.name === 'New video' && !library && !storycreation && !tourlibrary) {
			item.current = true;
		} else if (item.name === 'New experience' && storycreation && !library && !tourlibrary) {
			item.current = true;
		} else if (item.name === 'Experience library' && tourlibrary) {
			item.current = true;
		} else {
			item.current = false;
		}
	}
	return (
		<div className="flex flex-col items-stretch w-72 shrink-0 lg:h-screen ">
			<Transition.Root show={sidebarOpen} as={Fragment}>
				<Dialog as="div" className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
					<Transition.Child
						as={Fragment}
						enter="transition-opacity ease-linear duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="transition-opacity ease-linear duration-300"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<div className="fixed inset-0 bg-gray-900/80" />
					</Transition.Child>

					<div className="fixed inset-0 flex">
						<Transition.Child
							as={Fragment}
							enter="transition ease-in-out duration-300 transform"
							enterFrom="-translate-x-full"
							enterTo="translate-x-0"
							leave="transition ease-in-out duration-300 transform"
							leaveFrom="translate-x-0"
							leaveTo="-translate-x-full"
						>
							<Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
								<Transition.Child
									as={Fragment}
									enter="ease-in-out duration-300"
									enterFrom="opacity-0"
									enterTo="opacity-100"
									leave="ease-in-out duration-300"
									leaveFrom="opacity-100"
									leaveTo="opacity-0"
								>
									<div className="absolute left-full top-0 flex w-16 justify-center pt-5">
										<button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
											<span className="sr-only">Close sidebar</span>
											<XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
										</button>
									</div>
								</Transition.Child>
								{/* Sidebar component, swap this element with another sidebar if you like */}
								<div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
									<div className="flex h-16 shrink-0 items-center">
										<img className="h-8 w-auto" src="assets/img/logo.svg" alt="Your Company" />
									</div>
									<nav className="flex flex-1 flex-col">
										<ul role="list" className="flex flex-1 flex-col gap-y-7">
											<li>
												<ul role="list" className="-mx-2 space-y-1">
													{navigation.map((item) => (
														<li key={item.name}>
															<a href={item.href} className={classNames(item.current ? 'bg-black text-white'
																: 'text-gray-700 hover:text-white hover:bg-gray-300'
																, 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold')}>
																<item.icon className={classNames(item.current ? 'text-white'
																	: 'text-gray-400 group-hover:text-white', 'h-6 w-6 shrink-0')}
																	aria-hidden="true" />
																{item.name}
															</a>
														</li>
													))}
													<li key="Buy tokens">
															<a href="https://hopguides-video-creation.netlify.app/#/subscription/5" className={classNames('text-gray-700 hover:text-white hover:bg-gray-300'
																, 'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold')}>
																<CircleStackIcon className={classNames('text-gray-400 group-hover:text-white', 'h-6 w-6 shrink-0')}
																	aria-hidden="true" />
																Buy tokens
															</a>
														</li>
												</ul>
											</li>

											<li className="mt-auto" >
												<div
													className="group -mx-2 flex gap-x-3 rounded-md p-2 text-m font-semibold leading-6 text-gray-700"
												>
													<Cog6ToothIcon
														className="h-6 w-6 shrink-0 text-gray-400"
														aria-hidden="true"
													/>
													Available credits: {gettokens()}
												</div>
												<div className="border-t border-gray-300 w-full mt-3 mb-3"></div>
												<div className="mt-auto flex justify-end">
													<Menu as="div" className="relative">
														<Menu.Button className="-m-1.5 flex items-center p-1.5">
															<span className="sr-only">Open user menu</span>
															<UserCircleIcon className="h-8 w-8 rounded-full bg-gray-50" />
															<span className="hidden lg:flex lg:items-center">
																<ChevronDownIcon
																	className="ml-2 h-5 w-5 text-gray-400"
																	aria-hidden="true"
																/>
															</span>
														</Menu.Button>
														<Transition
															as={Fragment}
															enter="transition ease-out duration-100"
															enterFrom="transform opacity-0 scale-95"
															enterTo="transform opacity-100 scale-100"
															leave="transition ease-in duration-75"
															leaveFrom="transform opacity-100 scale-100"
															leaveTo="transform opacity-0 scale-95"
														>
															<Menu.Items
																className="absolute right-0 bottom-full z-10 w-36 origin-bottom-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
															>

																<Menu.Item>
																	{({ active }) => (
																		<a href="https://www.hopguides.com/about-us" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
																			About us
																		</a>
																	)}
																</Menu.Item>
																<Menu.Item>
																	{({ active }) => (
																		<a href="https://www.hopguides.com/contact" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
																			Contact
																		</a>
																	)}
																</Menu.Item>
																<Menu.Item>
																	{({ active }) => (
																		<a href="https://www.hopguides.com/pricing" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
																			Pricing
																		</a>
																	)}
																</Menu.Item>
																{admin && <Menu.Item>
																	{({ active }) => (
																		<a onClick={e => setUpdateapi(true)} className={classNames(active ? 'bg-gray-50' : ''
																			, 'block px-3 py-1 text-sm leading-6 text-gray-900')}>
																			Change d-id api
																		</a>
																	)}
																</Menu.Item>}

																<Menu.Item>
																	{({ active }) => (
																		<a onClick={e => handleLogout(e)}
																			className={classNames(
																				active ? 'bg-gray-50' : '',
																				'block px-3 py-1 text-sm leading-6 text-gray-900'
																			)}
																		>
																			Log out
																		</a>
																	)}
																</Menu.Item>

															</Menu.Items>
														</Transition>
													</Menu>
												</div>
											</li>
										</ul>
									</nav>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition.Root>

			{/* Sidebar component, swap this element with another sidebar if you like */}
			<div className="grow">

				{/* Logo */}
				<div className="p-5 hidden lg:block">
					<img className="h-10 w-auto" src="assets/img/logo.svg" alt="Your Company" />
				</div>

				<nav className="divide-y">

					<div className="p-5">
						<div className="menu">
							{navigation.map((item) => (
								<a key={item.name} href={item.href} className={classNames(item.current ? 'menu__item--active' : 'menu__item', 'menu__item')}>
									<item.icon className={classNames(item.current ? 'text-white'
										: 'text-black/60 group-hover:text-white', 'h-6 w-6 shrink-0')}
										aria-hidden="true" />
									{item.name}
								</a>
							))}

<a key="Buy tokens" href="https://hopguides-video-creation.netlify.app/#/subscription/5" className={classNames( '!text-red-500', 'menu__item', 'menu__item')}>
									<CircleStackIcon className={classNames(
										'text-black/60 group-hover:text-white !text-red-500', 'h-6 w-6 shrink-0')}
										aria-hidden="true" />
										Buy tokens
								</a>


								
						</div>
					</div>

				</nav>
			</div>

			{/* User */}
			<div className="p-5 border-t lg:border-none border-black/10">
				{admin && <div
					className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700"
				>
					<Cog6ToothIcon
						className="h-6 w-6 shrink-0 text-gray-400"
						aria-hidden="true"
					/>
					Available d-id credits: {getDidTokens()}
				</div>}
				{admin && <div className="border-t border-gray-300 w-full mt-3 mb-3"></div>}
				<div
					className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700"
				>
					<Cog6ToothIcon
						className="h-6 w-6 shrink-0 text-gray-400"
						aria-hidden="true"
					/>
					Available credits: {gettokens()}
				</div>
				<div className="border-t border-gray-300 w-full mt-3 mb-3"></div>
				{/* User */}
				<div>
					<Menu as="div" className="menu">
						<Menu.Button className="menu__item !h-auto !py-2  !gap-3">
							<span className="sr-only">Open user menu</span>
							<div
								className="group -mx-2 flex gap-x-3 rounded-md text-sm font-semibold leading-6 text-gray-700"
							>

								<EllipsisVerticalIcon className="h-6 w-6 shrink-0 text-gray-400"
									aria-hidden="true" />
							</div>
							<span>
								More
							</span>
						</Menu.Button>
						<Transition
							as={Fragment}
							enter="transition ease-out duration-100"
							enterFrom="transform opacity-0 scale-95"
							enterTo="transform opacity-100 scale-100"
							leave="transition ease-in duration-75"
							leaveFrom="transform opacity-100 scale-100"
							leaveTo="transform opacity-0 scale-95"
						>
							<Menu.Items
								className="absolute right-0 bottom-[70%] w-36 origin-bottom-right rounded-xl bg-white shadow-lg p-1 ring-1 ring-black/5 focus:outline-none"
							>
								<Menu.Item>
									{({ active }) => (
										<a href="https://www.hopguides.com/about-us" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
											About us
										</a>
									)}
								</Menu.Item>
								<Menu.Item>
									{({ active }) => (
										<a href="https://www.hopguides.com/contact" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
											Contact
										</a>
									)}
								</Menu.Item>
								<Menu.Item>
									{({ active }) => (
										<a href="https://www.hopguides.com/pricing" className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item')}>
											Pricing
										</a>
									)}
								</Menu.Item>
								{admin && <Menu.Item>
									{({ active }) => (
										<a onClick={e => setUpdateapi(true)} className={classNames(active ? 'active' : 'menu__item', 'menu__item')}>
											Change d-id api
										</a>
									)}
								</Menu.Item>}
								<Menu.Item>
									{({ active }) => (
										<a onClick={e => handleLogout(e)}
											className={classNames(active ? 'menu__item' : 'menu__item', 'menu__item'
											)}
										>
											Log out
										</a>
									)}
								</Menu.Item>
							</Menu.Items>
						</Transition>
					</Menu>
				</div>

			</div>

		</div>
	);
}

export default SideMenu;